const toFixed = (amount) => {
  return +(+amount).toFixed(2);
};

export default toFixed;
